import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
import i18next from 'i18next';

const gqlGetCpSubsubgroups = gql`
  query getCpSubsubgroups($where: String, $offset: Int, $limit: Int, $order: String) {
    getCpSubsubgroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
        isActive
        subgroupId
      }
      recordCount
    }
  }
`;

// export function useGetCompanyTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>) {
//   return ApolloReactHooks.useLazyQuery<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>(GetCompanyTypesDocument, baseOptions);
// }

function useGetSubsubGroupsLazyQuery() {
  return useLazyQuery(gqlGetCpSubsubgroups, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

type Props = { groupId?: number } & FsProps;

export const FieldSelectSubSubGroup = ({
  label = i18next.t('Υπο-υποκατηγορία'),
  name = 'subsubgroupId',
  defaultValues = {},
  groupId = null,
  ...rest
}: Props) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={groupId ? JSON.stringify({ groupId }) : ''}
      // @ts-ignore
      sbLabel={defaultValues?.cpSubgroup?.name ?? undefined}
      hook={useGetSubsubGroupsLazyQuery}
    />
  );
};

